module.exports = __webpack_public_path__ + "static/media/thumbpoll-logo.f3e89d9a.png";